export default __webpack_public_path__ + "static/spa_w.0966d4ba5fd16447e0e8e2d93ece05fe.png";